import { HttpParams } from '@angular/common/http';
import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UTILS } from 'src/app/entities/Utils';
import { Anagrafica, Company, DocType, GenericResponse, Role, Server, WorkflowType } from 'src/app/entities/various';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { ModalServiceService } from 'src/app/services/modal-service/modal-service.service';
import { UserService } from 'src/app/services/users/user.service';
import { PersonalDataComponent } from './personal-data/personal-data.component';
import { Location } from '@angular/common';
import { AppConfig } from 'src/app/app.config';
import { UtenteService } from 'src/app/services/users/utente.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { ConfigServiceService, ItemSelectProps } from 'src/app/services/config-service/config-service.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

export interface tipoNotifica{
  RC :boolean,
  MC :boolean,
  NS :boolean,
  NE :boolean,
  DT :boolean,
  mailNotifiche: string,
  push: string,
  token: string
}

@Component({
  selector: 'app-user-editor',
  templateUrl: './user-editor.component.html',
  styleUrls: ['./user-editor.component.css']
})
export class UserEditorComponent implements OnInit {

  @ViewChild('pdc', { static: false }) pdcomponent: PersonalDataComponent | undefined;

  navigator: string = '';
  toastConfig: { title: string, class: string } | undefined;

  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  utente: any;
  regimi : ItemSelectProps[] = [];

  id: string | number = '';
  editingUser: UserInfo | undefined;
  me: UserInfo | undefined;
  modifyDM7: boolean = false;
  modifySig: boolean = false;

  recWays = [{ "value": "Codice Univoco", "key": "C" }, { "value": "PEC", "key": "P" }];
  servers: Server[] = [];
  roles: Role[] = [];
  companies: Company[] = [];
  resellers: UserInfo[] = [];
  admins: UserInfo[] = [];
  doctypes: DocType[] = [];
  wfType: WorkflowType[] = [];

  params: HttpParams;
  getJson: boolean = false;

  hidePw: boolean = true;
  passwordFieldType: string = "password";
  easyMode : boolean = true;

  logoSafeUrl: SafeUrl | string = 'assets/placeholder.jpeg';

  notifiche : tipoNotifica={"RC":false,"MC":false,"NS":false,"NE":false,"DT":false, "mailNotifiche": "", "push": "", "token": ""};
  notificheDraft : tipoNotifica={"RC":false,"MC":false,"NS":false,"NE":false,"DT":false, "mailNotifiche": "", "push": "", "token": ""};

  serviceFatturazione: boolean = false;
  serviceArchOptima: boolean = false;
  serviceTimbrature: boolean = false;
  serviceISO: boolean = false;

  constructor(private route: ActivatedRoute, private userService: UserService, private utenteService: UtenteService, private loginService: LoginService,
    private translate: TranslateService, private confirmModalService: ModalServiceService, private sanitizer: DomSanitizer, private _location: Location,
    private toast : ToastService,private configService: ConfigServiceService, private ngbModal: NgbModal) {
    this.params = new HttpParams();
    this.params = this.params.append('endRow', 0);
    this.params = this.params.append('lastKeyVal', '');
    this.params = this.params.append('page', 1);
    this.params = this.params.append('pageDirection', 'FORWARD');
    this.params = this.params.append('pageSize', 12);
    this.params = this.params.append('pagination', true);
    this.params = this.params.append('paginationMode', 'SKIP');
    this.params = this.params.append('rows', 0);
    this.params = this.params.append('searchFilter', '{}');
    this.params = this.params.append('sortDir', 'ASC');
    this.params = this.params.append('sortKey', '');
    this.params = this.params.append('startRow', 0);
    this.params = this.params.append('totalPages', -1);
    this.params = this.params.append('totalRows', 0);
    this.innerWidth = window.innerWidth;

  }

  async ngOnInit(): Promise<void> {
    this.navigator = 'sidebar.utenti / ';
    this.route.params.subscribe((params: Params) => { this.id = params.id; });
    this.me = await this.loginService.getUserInfo();

    let list = (await this.configService.getJSON()).list;
    this.regimi = list.listRegimeFiscale;

    if (this.id != 'new') {
      // GESTIONE UTENTE GIÀ ESISTENTE
      await this.utenteService.getUtente(this.id).then(
        (res) => {
          this.utente = res.data;

          if (this.utente.img_logo_path) {
            this.logoSafeUrl = this.sanitizer.bypassSecurityTrustUrl(
              'data:image/png;base64,' + this.utente.img_logo_path
            );
          }
        }
      );

      this.navigator += (this.utente.email + ' - ' + this.utente.denominazione);
      this.utenteService.getServiziAttivi(this.utente!.user_id).then(
        (res) => {
          if (res.data.length > 0) {
            res.data.forEach((servizio: any) => {
              switch(servizio.service_name) {
                case 'fatturazione':
                this.serviceFatturazione = true;
                break;
              case 'consulenza':
                this.serviceISO = true;
                break;
              case 'timbratura':
                this.serviceTimbrature = true;
                break;
              case 'archoptima':
                this.serviceArchOptima = true;
                break;
              }
            });
          }
        }
      );
      this.utenteService.dettagliFatturazione(this.utente.user_id).then(
        (res) => {
          this.notifiche = JSON.parse(res.data.invio_notifiche);
          if (!this.notifiche.push) {
            this.notifiche.push = "";
          }
          if (!this.notifiche.token) {
            this.notifiche.token = "";
          }
        }
      );
      
    } else {
      // GESTIONE NUOVO UTENTE
      this.navigator += 'general.newUser';
    }

  }


  async disabilitaFatturazionePassiva() {
    // prima cancello i campi email pec e codice univoco dall'utente
    this.editingUser!.codice_univoco = "";
    this.editingUser!.email_pec = "";
    this.editingUser!.password_pec = "";
    this.editingUser!.mod_ric_fp= "";
    let response = await this.userService.disablePassive(this.editingUser!, this.me!.dms_user_id);
    console.log(response);

  }

  public setNotifica(type : string){
      if(type=='RC')
        this.notifiche.RC=!this.notifiche.RC;
      if(type=='MC')
        this.notifiche.MC=!this.notifiche.MC;
      if(type=='NS')
        this.notifiche.NS=!this.notifiche.NS;
      if(type=='NE')
        this.notifiche.NE=!this.notifiche.NE;
      if(type=='DT')
        this.notifiche.DT=!this.notifiche.DT;

      this.utenteService.invioNotifiche(this.utente.user_id, this.notifiche).then(
        (res) => {
          if (res.success)
          {
            this.toast.openToast(res.msg, "success");
          } else {
            this.toast.openToast(res.msg, "warning");
          }
        }
      );
  }

  openNotificheModal(content: TemplateRef<any>) {
    this.notificheDraft = { ...this.notifiche };
    this.ngbModal.open(content, { size: 'lg' });
  }

  saveNotificheModal(modal: any) {
    this.notifiche.push = this.notificheDraft.push;
    this.notifiche.token = this.notificheDraft.token;

    this.utenteService.invioNotifiche(this.utente.user_id, this.notifiche).then(
      (res) => {
        if (res.success) {
          this.toast.openToast(res.msg, "success");
          modal.close();
        } else {
          this.toast.openToast(res.msg, "warning");
        }
      }
    );
  }

  openLogoModal(content: TemplateRef<any>) {
    this.ngbModal.open(content, { size: 'lg' });
  }

  salvaLogoAzienda(event: any, modal: any) {
    let file = (event.target.files as FileList)[0];

    if (!file) return;

    const tipiAmmessi = ['image/jpeg', 'image/png', 'image/webp'];
    if (!tipiAmmessi.includes(file.type)) {
      this.toast.openToast("Errore: il file selezionato non è un'immagine valida (ammessi JPG, PNG, WEBP).", "error");
      event.target.value = ''; // Reset dell'input
      return;
    }


    const reader = new FileReader();
    reader.onload = (e: any) => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        const larghezza = img.width;
        const altezza = img.height;

        if (larghezza <= 0 || altezza <= 0) {
          this.toast.openToast("Errore: impossibile leggere le dimensioni dell'immagine.", "warning");
          event.target.value = '';
          return;
        }

        const dimensioneLogo = 600;
        const scala = Math.min(1, dimensioneLogo / larghezza, dimensioneLogo / altezza);
        const larghezzaDestinazione = Math.round(larghezza * scala);
        const altezzaDestinazione = Math.round(altezza * scala);
        const destinazioneX = Math.floor((dimensioneLogo - larghezzaDestinazione) / 2);
        const destinazioneY = Math.floor((dimensioneLogo - altezzaDestinazione) / 2);
        const canvas = document.createElement('canvas');
        canvas.width = dimensioneLogo;
        canvas.height = dimensioneLogo;

        const context = canvas.getContext('2d');
        if (!context) {
          this.toast.openToast("Errore durante il ridimensionamento dell'immagine.", "error");
          event.target.value = '';
          return;
        }

        if (file.type === 'image/jpeg') {
          context.fillStyle = '#ffffff';
          context.fillRect(0, 0, dimensioneLogo, dimensioneLogo);
        }

        context.drawImage(img, destinazioneX, destinazioneY, larghezzaDestinazione, altezzaDestinazione);
        const logoDataUrl = canvas.toDataURL(file.type);
        const logoBlob = this.dataUrlToBlob(logoDataUrl);
        const limitePeso = 700 * 1024;

        if (logoBlob.size > limitePeso) {
          const pesoInMb = (logoBlob.size / (1024 * 1024)).toFixed(2);
          this.toast.openToast(`Errore: il file ridimensionato e troppo grande (${pesoInMb} MB). Il limite massimo e 700 KB.`, "error");
          event.target.value = '';
          return;
        }

        let formData = new FormData();
        formData.append("file", logoBlob, file.name);

        this.utente.img_logo_path = logoDataUrl;

        this.utenteService.caricaLogo(this.utente.user_id, formData).then(
          (res) => {
            this.utente.img_logo_path = res.msg;
            this.toast.openToast("Logo caricato correttamente", "success");
            modal.close();
          }
        );
      };
    };
    reader.readAsDataURL(file);
  }

  private dataUrlToBlob(dataUrl: string): Blob {
    const parts = dataUrl.split(',');
    const mime = parts[0].match(/:(.*?);/)?.[1] || 'image/png';
    const binary = atob(parts[1]);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    return new Blob([bytes], { type: mime });
  }

  getValues(list: any[], key: string, value: string) {
    return list.filter((o: any) => o[key] == value).length > 0
      ? list.filter((o: any) => o[key] == value)
      : list;
  }

  setSessionUser() {
    //let obj: UserInfo = new UTILS().deepCopy(this.utente);
    this.loginService.setSessionUserInfo(this.utente);
  }


  convalidaDati() {
    
    if (this.utente.denominazione == "") {
      this.toastConfig = { class: "warning", title: "La denominazione deve essere presente" };   
      return false;
    }

    if (this.utente.partita_iva == "" && this.utente.codice_fiscale == "") {
      this.toastConfig = { class: "warning", title: "Almeno un valore tra codice fiscale e partita IVA deve essere presente" };   
      return false;
    }

    if (this.utente.indirizzo == "") {
      this.toastConfig = { class: "warning", title: "L'indirizzo deve essere presente" };   
      return false;
    }

    if (this.utente.cap == "") {
      this.toastConfig = { class: "warning", title: "Il CAP deve essere presente" };   
      return false;
    }

    if (this.utente.comune == "") {
      this.toastConfig = { class: "warning", title: "Il comune deve essere presente" };   
      return false;
    }

    if (this.utente.provincia == "") {
      this.toastConfig = { class: "warning", title: "La provincia deve essere presente" };   
      return false;
    }

    if (this.utente.nazione == "") {
      this.toastConfig = { class: "warning", title: "La nazione deve essere presente" };   
      return false;
    }

    return true;
  }

  async save() {
    
    let label: string = await new UTILS().getTranslateTitle(this.translate, "modal.labels.save");
    let message: string = await new UTILS().getTranslateTitle(this.translate, "modal.messages.save");
    let check = await this.confirmModalService.openConfirm(label, message);


    if (check) {
      if(this.convalidaDati()){
       
        this.utenteService.aggiornaProfilo(this.utente).then(
          (res) => {
            if (res.success) {
              this.toastConfig = { class: "success", title: "Il profilo utente è stato aggiornato correttamente" };
            }
          }
        );
      }
    }
  }

  async deleteUser() {
    let label: string = await new UTILS().getTranslateTitle(this.translate, "modal.labels.delete");
    let message: string = await new UTILS().getTranslateTitle(this.translate, "modal.messages.delete");
    let check = await this.confirmModalService.openConfirm(label, message);
    if (check) {
      let response = await this.userService.deleteUser(this.me!.dms_user_id, this.editingUser!.dms_user_id);
      if (response.success) {
        this.toastConfig = { class: "success", title: await new UTILS().getTranslateTitle(this.translate, "toast.save.success") };
        this._location.back();

      } else {
        this.toastConfig = { class: "warning", title: response.msg };
      }
    }
  }

  async enable() {
    let label: string = await new UTILS().getTranslateTitle(this.translate, "modal.labels.save");
    let message: string = await new UTILS().getTranslateTitle(this.translate, "modal.messages.save");
    let check = await this.confirmModalService.openConfirm(label, message);
    if (check) {
      let response = await this.userService.manageEnable(this.me!.dms_user_id, this.editingUser!.dms_user_id, this.editingUser?.abilitato == 1 ? false : true);
      if (response.success) {
        this.toastConfig = { class: "success", title: await new UTILS().getTranslateTitle(this.translate, "toast.save.success") };
      } else {
        this.toastConfig = { class: "warning", title: response.msg };
      }
      this.ngOnInit();
    }

  }

  async changeUserVisibility() {
    let label: string = await new UTILS().getTranslateTitle(this.translate, "modal.labels.save");
    let message: string = await new UTILS().getTranslateTitle(this.translate, "modal.messages.save");
    let check = await this.confirmModalService.openConfirm(label, message);
    if (check) {
      let response = await this.userService.manageUserStatus(this.me!.dms_user_id, this.editingUser!.dms_user_id, this.editingUser!.abilitato );
      if (response.success) {
        this.toastConfig = { class: "success", title: await new UTILS().getTranslateTitle(this.translate, "toast.save.success") };
        return true;
      } else {
        this.toastConfig = { class: "warning", title: response.msg };
        return false;
      }
    }
    return false;
  }

  async nascondiUtente(){
      this.editingUser!.abilitato = 3;
      this.changeUserVisibility().then( (result)=>{
            if(result)
                this.ngOnInit();
            else
                this.editingUser!.abilitato = 0;
      });
              
  }

  async mostraUtente(){
    this.editingUser!.abilitato = 0;
    this.changeUserVisibility().then( (result)=>{
      if(result)
          this.ngOnInit();
      else
          this.editingUser!.abilitato = 3;
    });
  }


  async resetPassword() {
    let label: string = await new UTILS().getTranslateTitle(this.translate, "modal.labels.confirm");
    let message: string = await new UTILS().getTranslateTitle(this.translate, "modal.messages.change_pw");
    let check = await this.confirmModalService.openConfirm(label, message);
    if (check) {
      let response = await this.userService.resetPassword(this.utente.user_id);
      if (response.success) {
        this.toastConfig = { class: "success", title: await new UTILS().getTranslateTitle(this.translate, "toast.operation.success") };
      } else {
        this.toastConfig = { class: "warning", title: response.msg };
      }
    }

  }

  changeVisibility() {
    this.hidePw = !this.hidePw;
    if (this.hidePw) {
      this.passwordFieldType = 'password'
    } else {
      this.passwordFieldType = 'text'
    }
  }

  async cambiaFatturazione() {
    console.log(this.serviceFatturazione);
  }

  async cambiaArchOptima() {
    console.log(this.serviceArchOptima);
    this.utenteService.modificaServizio(this.utente.user_id, "ArchOptima", this.serviceArchOptima).then(
      (res) => {
        console.log(res);
      }
    );
  }

  async cambiaTimbrature() {
    console.log(this.serviceTimbrature);
  }

  async cambiaConsulenzaISO() {
    console.log(this.serviceISO);
  }
}
